/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import FPItemTypes from './FPItemTypes';
import './FPDnDCard.scss';
// eslint-disable-next-line import/no-unresolved
import * as images from 'url:../../../assets/imagesFP/*.png';
import DnDCardProps from '../../../types/components/DnDCardProps';

const FPDnDCard = function FPDnDCard({ id, text, moveCard, findCard }: DnDCardProps) {
  const originalIndex = findCard(id).index;
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: FPItemTypes.CARD,
      item: { id, originalIndex },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          moveCard(droppedId, originalIndex);
        }
      },
    }),
    [id, originalIndex, moveCard]
  );
  const [, drop] = useDrop(
    () => ({
      accept: FPItemTypes.CARD,
      canDrop: () => false,
      hover({ id: draggedId }) {
        if (draggedId !== id) {
          const { index: overIndex } = findCard(id);
          moveCard(draggedId, overIndex);
        }
      },
    }),
    [findCard, moveCard]
  );
  const opacity = isDragging ? 0.5 : 1;
  return (
    <div
      ref={node => drag(drop(node))}
      style={{ opacity }}
      className="results-card"
      data-testid={`card-${id}`}
    >
      <div
        className="grid-icon--container"
        data-testid="grid-icon--container"
        onTouchStart={e => e.preventDefault()}
      >
        <img
          src={images['dnd-icon']}
          alt=""
          role="presentation"
          className="grid-icon"
          onContextMenu={e => e.preventDefault()}
        />
      </div>
      <div className="results-card-image">
        <img src={images[`${id}`]} alt="" role="presentation" />
      </div>
      <div className="results-card-text">{text}</div>
    </div>
  );
};

FPDnDCard.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  moveCard: PropTypes.func.isRequired,
  findCard: PropTypes.func.isRequired,
};

export default React.memo(FPDnDCard);